import { UnitFormState } from "components/admin/common/dl_unit/UnitForm";

export const EMPTY_FORM: UnitFormState = {
  slug: "",
  uType: "",
  uDate: null,
  num: "",
  fVals: {},
};
